<template>
  <div
    class="modal fade entity-modal-gallery"
    :id="hotel.code"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="hotel.code"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <SocialMediaMenu v-if="hotel.overviewPath" :hotel="hotel" />
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="modal-body position-relative">
          <div class="wrap-main-slider">
            <div class="spinner-box spinner-box-slider" id="spinner-load-gallery">
              <div class="spinner-loader spinner-loader--white spinner-slider">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <div class="gallery-slider"></div>
          </div>

          <div class="wrap-navbar-galleries bg-white">
            <nav class="navbar navbar-expand-lg navbar-light">
              <ul class="nav nav-tabs">
                <li
                  class="nav-item"
                  v-for="({ code, name }, index) in categories"
                  :key="code + index"
                >
                  <span class="nav-link" :data-gallery="code">{{ name }}</span>
                </li>
              </ul>
            </nav>
          </div>

          <div class="gallery-thumbs-slider">
            <!-- / thumbs-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialMediaMenu from '@/components/SocialMediaMenu'
import { buildImageUrl, buildImageUrlFromMedia } from '@/infrastructure/Utils'

export default {
  components: {
    SocialMediaMenu
  },
  props: {
    hotel: Object
  },
  mounted: function () {
    this.initGallery()
  },
  computed: {
    gallery() {
      return this.hotel.galleries.reduce(
        (slides, { category, gallery }) => ({
          ...slides,
          [category.toLowerCase()]: gallery.map((slide, index) => {
            let item
            if (slide.mimeType && slide.mimeType.includes('video')) {
              item = {
                id: this.hotel.code + index,
                name: slide.name,
                posterUrl: buildImageUrl(slide.posterUrl, 'GalleryLightbox', slide.gravity),
                thumbnailUrl: buildImageUrl(
                  slide.thumbnailUrl,
                  'GalleryLightboxThum',
                  slide.gravity
                ),
                videoUrl: slide.url,
                title: slide.title,
                languagesInfo: slide.captions
              }
            } else {
              item = {
                alt: slide.altText,
                src: buildImageUrlFromMedia(slide, 'GalleryLightbox'),
                srcThumbnail: buildImageUrlFromMedia(slide, 'GalleryLightboxThum')
              }
            }
            return item
          })
        }),
        {}
      )
    },
    categories() {
      return this.hotel.galleries.map(({ category }) => ({
        code: category.toLowerCase(),
        name: category
      }))
    }
  },
  methods: {
    initGallery() {
      if (typeof WeModalGallery === 'undefined') {
        return
      }

      // eslint-disable-next-line no-undef
      global.weModalGallerySliders = global.weModalGallerySliders || []
      global.weModalGallerySliders.push({
        selector: `#${this.hotel.code}`,
        slides: this.gallery,
        isVueGallery: true
      })

      // eslint-disable-next-line no-undef
      global.WeSetupVideo.init()
      global.WeModalGallery.init()
    }
  }
}
</script>
